// ContactPage.jsx
import React from 'react';
import { SEOHead } from '../components/SEOHead';
import {
    ContactPageContainer,
    ContactForm,
    SocialLinks,
    ContactGrid,
    FormContainer,
    SocialContainer,
    SectionTitle,
    SectionSubtitle,
    SocialCard,
    SocialIcon,
    StatusMessage
} from './ContactPage.styled';
import { useContactForm } from '../hooks/useContactForm';
import itacaEmailImage from '../assets/images/itaca-email.png';
import itacaInstagramImage from '../assets/images/itaca-instagram.png';
import itacaTiktokImage from '../assets/images/itaca-tiktok.png';
import itacaWhatsappImage from '../assets/images/itaca-whatsapp.png';

function ContactPage() {
    const {
        formData,
        handleChange,
        handleSubmit,
        isSubmitting,
        submitStatus,
        errors // ✅ AÑADIDO - Esto es lo que faltaba
    } = useContactForm();

    const socialLinks = [
        {
            platform: 'Instagram',
            url: 'https://www.instagram.com/duoacolor',
            icon: itacaInstagramImage,
            color: '#E4405F',
            description: 'Síguenos para ver nuestro trabajo'
        },
        {
            platform: 'TikTok',
            url: 'https://www.tiktok.com/@duoacolor',
            icon: itacaTiktokImage,
            color: '#000000',
            description: 'Descubre nuestro contenido viral'
        },
        {
            platform: 'WhatsApp',
            url: 'https://wa.me/+34722177469',
            icon: itacaWhatsappImage,
            color: '#25D366',
            description: 'Chatea directamente con nosotros'
        },
        {
            platform: 'Email',
            url: 'mailto:contacto@duoacolor.com',
            icon: itacaEmailImage,
            color: '#EA4335',
            description: 'Envíanos un correo electrónico'
        }
    ];

    return (
        <ContactPageContainer>
            <SEOHead
                title="Contacto - Duo a Color España"
                description="Contacta con Duo a Color (duoacolor) para tu diseño personalizado de punch needle. Artesanía textil única hecha en España. Totebags, cojines y más."
                path="/contact"
            />
            <SectionTitle>Hablemos</SectionTitle>
            <SectionSubtitle>
                Estamos aquí para hacer realidad tus ideas. ¡Contáctanos!
            </SectionSubtitle>

            <ContactGrid>
                <FormContainer>
                    <ContactForm onSubmit={handleSubmit}>
                        <div className="form-group">
                            <input
                                type="text"
                                name="name"
                                placeholder="Tu nombre completo"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                className={errors.name ? 'error' : ''}
                            />
                            {errors.name && <span className="error-message">{errors.name}</span>}
                        </div>

                        <div className="form-group">
                            <input
                                type="email"
                                name="email"
                                placeholder="tu.correo@ejemplo.com"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                className={errors.email ? 'error' : ''}
                            />
                            {errors.email && <span className="error-message">{errors.email}</span>}
                        </div>

                        <div className="form-group">
                            <textarea
                                name="message"
                                placeholder="Cuéntanos sobre tu proyecto..."
                                rows="6"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                className={errors.message ? 'error' : ''}
                            />
                            {errors.message && <span className="error-message">{errors.message}</span>}
                        </div>

                        <div className="form-group checkbox-group">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="privacyAccepted"
                                    checked={formData.privacyAccepted}
                                    onChange={handleChange}
                                />
                                <span className="checkbox-text">
                                    He leído y acepto la{' '}
                                    <a href="/politica-privacidad" target="_blank" rel="noopener noreferrer">
                                        Política de Privacidad
                                    </a>
                                </span>
                            </label>
                            {errors.privacy && <span className="error-message">{errors.privacy}</span>}
                        </div>

                        <div className="form-group checkbox-group">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name="storyConsent"
                                    checked={formData.storyConsent}
                                    onChange={handleChange}
                                />
                                <span className="checkbox-text">
                                    (Opcional) Autorizo a Duo a Color a compartir parte de mi historia como inspiración para su comunidad
                                </span>
                            </label>
                        </div>

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={isSubmitting ? 'submitting' : ''}
                        >
                            {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                        </button>

                        {submitStatus === 'success' && (
                            <StatusMessage type="success">
                                ✅ ¡Mensaje enviado! Te contactaremos pronto.
                            </StatusMessage>
                        )}

                        {submitStatus === 'error' && (
                            <StatusMessage type="error">
                                ❌ Error al enviar. Por favor, inténtalo de nuevo.
                            </StatusMessage>
                        )}
                    </ContactForm>
                </FormContainer>

                <SocialContainer>
                    <h3>Conectemos por aquí también</h3>
                    <SocialLinks>
                        {socialLinks.map((social, index) => (
                            <SocialCard
                                key={social.platform}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ '--accent-color': social.color }}
                                delay={index * 100}
                            >
                                <SocialIcon>
                                    <img src={social.icon} alt={social.platform} className="social-icon-image" />
                                </SocialIcon>
                                <div className="social-info">
                                    <span className="platform">{social.platform}</span>
                                    <span className="description">{social.description}</span>
                                </div>
                                <div className="arrow">→</div>
                            </SocialCard>
                        ))}
                    </SocialLinks>
                </SocialContainer>
            </ContactGrid>
        </ContactPageContainer>
    );
}

export default ContactPage;